import { z } from 'zod';

/**
 * Which face of Home is showing. Absent = the dashboard (what every fresh visit
 * gets); `chat` = the conversation. Keeping it in the URL means Back, reload
 * and a link to "my conversation" all behave, and returning to plain `/home`
 * later shows Home again instead of whatever chat is still open.
 */
export const homeSearchSchema = z.object({
  view: z.literal('chat').optional(),
});

export type HomeSearch = z.infer<typeof homeSearchSchema>;
